import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VList,{attrs:{"three-line":"","dense":""}},[_vm._l((_vm.eans),function(ean,index){return [_c('ProductsListItem',{key:(ean + "-item"),attrs:{"disabled":_vm.disabled,"readonly":_vm.readonly,"ean":ean}}),_vm._v(" "),(index !== _vm.length - 1)?_c(VDivider,{key:(ean + "-divider"),attrs:{"horizontal":"","dark":""}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }